<template>
    <div>
        <div class="chart" style="height: 17vh; flex: 1" id="waterConditionWarn"></div>
    </div>
</template>

<script>
import * as echarts from "echarts/core";
import {
    TooltipComponent,
    TitleComponent,  // 新增：标题组件
    GridComponent    // 新增：网格组件
} from "echarts/components";
// 补充缺失的图表类型导入
import {
    PieChart,
    CustomChart,     // 新增：自定义图表
    BarChart,        // 新增：柱状图
    PictorialBarChart // 新增：象形柱图
} from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
    TooltipComponent,
    TitleComponent,
    GridComponent,
    PieChart,
    CustomChart,
    BarChart,
    PictorialBarChart,
    CanvasRenderer,
    LabelLayout
]);
export default {
    name: "waterConditionWarn",
    mounted() {
        this.initWaterConditionWarnChart();
    },
    methods:{
        initWaterConditionWarnChart() {
            const chartDom = document.getElementById("waterConditionWarn");
            if (!chartDom) return;

            chartDom.style.height = '35vh';
            chartDom.style.width = '100%';

            this.sewageChart = echarts.init(chartDom);

            const CubeLeft = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    // 会canvas的应该都能看得懂，shape是从custom传入的
                    const xAxisPoint = shape.xAxisPoint;
                    const c0 = [shape.x, shape.y];
                    const c1 = [shape.x - 33, shape.y - 10];
                    const c2 = [xAxisPoint[0] - 33, xAxisPoint[1] - 0];
                    const c3 = [xAxisPoint[0], xAxisPoint[1] + 13];
                    ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath();
                },
            });
            const CubeRight = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    const xAxisPoint = shape.xAxisPoint;
                    const c1 = [shape.x, shape.y];
                    const c2 = [xAxisPoint[0], xAxisPoint[1] + 14];
                    const c3 = [xAxisPoint[0] + 33, xAxisPoint[1] - 9];
                    const c4 = [shape.x + 33, shape.y - 9];
                    ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
                },
            });
            const CubeTop = echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    const c1 = [shape.x, shape.y];
                    const c2 = [shape.x + 33, shape.y - 9];
                    const c3 = [shape.x, shape.y - 18];
                    const c4 = [shape.x - 33, shape.y - 10];
                    ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
                },
            });

            echarts.graphic.registerShape('CubeLeft', CubeLeft);
            echarts.graphic.registerShape('CubeRight', CubeRight);
            echarts.graphic.registerShape('CubeTop', CubeTop);

            const MAX = [100, 100, 100, 100];
            const yList = [32, 58, 120, 64];
            const xList = ['中型','河道', '积淹点', '泵站水位'];
            const color = ['#CEF4FF', '#CEF4FF', '#CEF4FF', '#CEF4FF'];
            const xData = xList.map((item, index) => {
                return {
                    value: item,
                    textStyle: {
                        color: color[index],
                    },
                };
            });
            const dom = 1300;
            const barWidth = dom / 20;
            const colors = [
                {
                    type: 'linear',
                    x: 0,
                    x2: 1,
                    y: 0,
                    y2: 0,
                    colorStops: [
                        {
                            offset: 0,
                            color: '#00FFFF',
                        },
                        {
                            offset: 0.5,
                            color: '#00FFFF',
                        },
                        {
                            offset: 0.5,
                            color: '#11A6D0',
                        },
                        {
                            offset: 1,
                            color: '#11A6D0',
                        },
                    ],
                },
                {
                    type: 'linear',
                    x: 0,
                    x2: 1,
                    y: 0,
                    y2: 0,
                    colorStops: [
                        {
                            offset: 0,
                            color: '#FFD05C',
                        },
                        {
                            offset: 0.5,
                            color: '#FFD05C',
                        },
                        {
                            offset: 0.5,
                            color: '#DEA821',
                        },
                        {
                            offset: 1,
                            color: '#DEA821',
                        },
                    ],
                },
                {
                    type: 'linear',
                    x: 0,
                    x2: 1,
                    y: 0,
                    y2: 0,
                    colorStops: [
                        {
                            offset: 0.5,
                            color: 'rgba(68,190,255,1)',
                        },
                        {
                            offset: 0.5,
                            color: 'rgba(53,133,177,1)',
                        },
                        {
                            offset: 1,

                            color: 'rgba(53,133,177,1)',
                        },
                    ],
                },
                {
                    type: 'linear',
                    x: 0,
                    x2: 1,
                    y: 0,
                    y2: 0,
                    colorStops: [
                        {
                            offset: 1,
                            color: '#3BECA2',
                        },
                        {
                            offset: 0.5,
                            color: '#2DB47C',
                        },
                        {
                            offset: 1,
                            color: '#2DB47C',
                        },
                    ],
                },
            ];
            const option = {
                title: {
                    text: '',
                    textStyle: {
                        color: '#00FFFF',
                        fontWeight: '800',
                        fontSize: `14`,
                    },
                    left: 'center',
                    top: '5%',
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: '{c1}',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                grid: {
                    left: '10%',
                    right: '10%',
                    top: 50,
                    bottom: 70,
                },
                xAxis: [
                    {
                        axisTick: {
                            show: false,
                        },
                        data: xData,

                        show: true,
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: true,
                            fontSize: 12,
                            textStyle: {
                                fontSize: 12,
                                fontFamily: 'PangMenZhengDao',
                                fontWeight: 'bold',
                                color: '#CEF4FF',
                                lineHeight: 40,
                            },
                        },
                    },
                    {
                        axisLine: {
                            show: false, //不显示坐标轴线
                        },
                        axisTick: {
                            show: false,
                        },
                        data: yList, //y轴数据
                        show: true,
                        type: 'category',
                        splitLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: true,
                            fontSize: 12,
                            textStyle: {
                                fontSize: 14,
                                fontFamily: 'PangMenZhengDao',
                                fontWeight: 'bold',
                                color: '#CEF4FF',
                                lineHeight: 40,
                            },
                        },
                    },
                ],

                yAxis: {
                    show: true,
                    splitNumber: 4,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255,255,255,0.2)',
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(255,255,255,0.2)',
                        },
                    },
                    axisLabel: {
                        color: '#CEF4FF',
                        textStyle: {
                            fontSize: 15,
                        },
                    },
                },
                series: [
                    {
                        type: 'custom',
                        renderItem: function (params, api) {
                            const location = api.coord([api.value(0), api.value(1)]);
                            return {
                                type: 'group',
                                children: [
                                    {
                                        type: 'CubeLeft',
                                        shape: {
                                            api,
                                            x: location[0],
                                            y: location[1],
                                            xAxisPoint: api.coord([api.value(0), 0]),
                                        },
                                        style: {
                                            fill: 'rgba(221,221,221,0.2)',
                                        },
                                    },
                                    {
                                        type: 'CubeRight',
                                        shape: {
                                            api,
                                            x: location[0],
                                            y: location[1],
                                            xAxisPoint: api.coord([api.value(0), 0]),
                                        },
                                        style: {
                                            fill: 'rgba(221,221,221,0.3)',
                                        },
                                    },
                                    {
                                        type: 'CubeTop',
                                        shape: {
                                            api,
                                            x: location[0],
                                            y: location[1],
                                            xAxisPoint: api.coord([api.value(0), 0]),
                                        },
                                        style: {
                                            fill: 'rgba(221,221,221,0.4)',
                                        },
                                    },
                                ],
                            };
                        },
                        data: MAX,
                    },
                    {
                        type: 'bar',
                        barWidth: barWidth,
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    return colors[params.dataIndex % 7];
                                },
                            },
                        },
                        data: yList,
                    },
                    {
                        z: 2,
                        type: 'pictorialBar',
                        data: yList,
                        symbol: 'diamond',
                        symbolOffset: [0, '50%'],
                        symbolSize: [barWidth, barWidth * 0.4],
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    return colors[params.dataIndex % 7];
                                },
                            },
                        },
                    },
                    {
                        z: 3,
                        type: 'pictorialBar',
                        symbolPosition: 'end',
                        data: yList,
                        symbol: 'diamond',
                        symbolOffset: [0, '-50%'],
                        symbolSize: [barWidth, barWidth * 0.4],
                        itemStyle: {
                            normal: {
                                borderWidth: 0,
                                color: function (params) {
                                    return colors[params.dataIndex % 7].colorStops[0].color;
                                },
                            },
                        },
                    },
                ],
            };
            option && this.sewageChart.setOption(option);
        },
    }
}
</script>

<style scoped>

</style>